import { NovelizovanyPredpisListApi, SuvisiaciProces as ProcesGenerated } from 'indexer-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { indexerPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import PredpisZbierky from '../../../model/legislativnyMaterial/PredpisZbierky';

const client = new NovelizovanyPredpisListApi(apiConfiguration(indexerPrefixPath));

function map(novelizovanyPredpisList: ProcesGenerated[]): PredpisZbierky[] {
  return novelizovanyPredpisList.map(novelizovanyPredpis => ({
    iri: novelizovanyPredpis.iri.split('/').slice(0, 5).join('/'),
    menovka: novelizovanyPredpis.menovka,
    popis: novelizovanyPredpis.popis,
  }));
}

function formatDopytQueryParam(dopyt: string): string {
  return dopyt ? `"${dopyt.trim()}"` : '';
}

// eslint-disable-next-line import/prefer-default-export
export const fetchNovelizovanyPredpisList = async (
  dopyt?: string,
  limit?: number,
  headers?: object,
): Promise<ClientResponse<PredpisZbierky[]>> => {
  const {
    data,
    status,
  } = await client.getNovelizovanyPredpisList(
    'predpisZbierky',
    formatDopytQueryParam(dopyt),
    'hodnotaPola asc',
    limit,
    headers,
  );

  return {
    data: map(data),
    responseCode: status,
  };
};
